import Link from 'next/link'
import { Image } from 'react-components/atoms'
import React from 'react'
import { CAS_DOMAIN } from 'utils'

const FindItSideItem = ({ item }) => {
  return (
    <div className="riviste-side__item">
      {item.image && (
        <Image
          src={CAS_DOMAIN + item.image}
          className="riviste-side__item__image"
          width={60}
          height={80}
          alt={item.titolo?.toAltTitle()}
          title={item.titolo?.toAltTitle()}
        />
      )}
      <Link legacyBehavior href={item.url?.replace('/sesamo/sesamo', '/sesamo')}>
        <a className="riviste-side__item__title">{item.titolo}</a>
      </Link>
    </div>
  )
}

export default FindItSideItem
